<div
  routerLink="/payment"
  class="deposit-banner group flex h-[12.4rem] w-full cursor-pointer items-center justify-center overflow-hidden rounded-[2rem] bg-[linear-gradient(348deg,#2E4E9F_11.95%,#232E66_97.31%)] custom-transition-bg before:bg-[linear-gradient(348deg,#3657AF_11.95%,#2A3778_97.31%)] lg:h-[10.2rem] lg:rounded-[1.6rem]"
>
  <div
    class="z-[1] flex h-full w-full flex-col items-start justify-between rounded-[2rem] border-[0.2rem] border-solid border-[rgba(86,122,212,0.12)] p-[2rem] custom-transition-all group-hover:border-[rgba(86,122,212,0.32)] lg:rounded-[1.6rem] lg:p-[1.6rem]"
  >
    <div class="flex flex-col space-y-[0.2rem]">
      <span
        i18n="@@main.deposit.balancedep"
        class="text-[1.6rem] font-400 leading-[2.4rem] text-white lg:text-[1.3rem] lg:leading-[1.6rem]"
        >Пополнить баланс +</span
      >
      @if (authState.user() && isLg()) {
        @if (userBonusState.secretCode()) {
          <span class="text-[1.1rem] font-350 leading-[1.4rem] text-green-500">
            <ng-container
              [ngTemplateOutlet]="codeDescription"
              [ngTemplateOutletContext]="{ secretCode: userBonusState.secretCode() }"
            ></ng-container>
          </span>
        } @else {
          <span class="text-[1.1rem] font-350 leading-[1.4rem] text-green-500">
            <span i18n="@@main.deposit.balance">На вашем балансе</span> {{ authState.user()?.balanceUsd }}
          </span>
        }
      }
    </div>
    <button
      class="flex h-[3rem] items-center justify-center space-x-[0.6rem] rounded-[0.8rem] bg-green-400 px-[1rem] !text-green-100 custom-transition-all hover:bg-green-500 hover:!text-green-200 lg:h-[2.6rem] lg:space-x-[0.4rem]"
    >
      <span i18n="@@main.deposit.button" class="text-[1.2rem] font-400 leading-[1.6rem]">Пополнить</span>
      <i class="icon_new icon_plus text-[1.6rem] lg:text-[1.4rem]"></i>
    </button>
  </div>
  <div class="deposit-shadow"></div>
  <div class="deposit-money"></div>
</div>

<ng-template #codeDescription let-secretCode="secretCode">
  @if (secretCode) {
    @if (secretCode.bonusAmountPct > 0) {
      <span> +{{ secretCode.bonusAmountPct | number }}% </span>
    }

    @if (secretCode.bonusAmountPct > 0 && secretCode.bonusAmountUsd > 0) {
      <span i18n="@@payment.secret_code.and"> и </span>
    }

    @if (secretCode.bonusAmountUsd > 0) {
      <span> ${{ secretCode.bonusAmountUsd | number: '1.0-0' }}</span>
    }

    @if (secretCode.minDepositAmountUsd > 0) {
      <span i18n="@@payment.secret_code.from"> при пополнении от </span>
      <span>${{ secretCode.minDepositAmountUsd | number: '1.0-0' }}</span>
    }
  }
</ng-template>
